import { Api } from 'shared/types';
import { UpdatingOptionsSummaryData } from '../types';

const MANAGEMENT_ACT = 'MODIFICATION';

async function postUpdatingOptionsSummary({
  saleDeviceId,
  apiUpdatingOptionsSummary,
  token,
  body
}: {
  saleDeviceId: string | null;
  apiUpdatingOptionsSummary: Api;
  token: string;
  body: Record<string, unknown>;
}): Promise<UpdatingOptionsSummaryData> {
  const params = new URLSearchParams({
    managementAct: MANAGEMENT_ACT,
    saleDeviceId: saleDeviceId ?? ''
  });

  const url = `${apiUpdatingOptionsSummary.url}?${params.toString()}`;
  const response = await fetch(url, {
    method: apiUpdatingOptionsSummary.method,
    headers: {
      Authorization: `AuthBypass ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw new Error('Failed to fetch summary data');
  }

  const data = await response.json();
  if (data.status && data.status >= 400) {
    throw new Error('An error occurred');
  }
  return data;
}

export default postUpdatingOptionsSummary;
